export const getFromStorage = (key: string): string | null => {
  return localStorage.getItem(key) || sessionStorage.getItem(key);
};

/**
 * localStorage keys that hold UI preferences (theme, light/dark mode, language)
 * rather than session/auth data. These are safe to keep across logout so the
 * public pages (login, register, …) can restore the look the user last chose —
 * the login page reads them via bootstrapThemeFromStorage().
 */
const PREFERENCE_KEYS = ["Theme-Name", "App-Mode", "Theme", "Mode", "Language"];

/**
 * Clears session/auth data on logout while preserving UI preference keys.
 * Use this in place of localStorage.clear() wherever we sign the user out, so
 * the chosen theme survives into the next login screen.
 */
export const clearAuthStorage = (): void => {
  const preserved = PREFERENCE_KEYS.map(
    (key) => [key, localStorage.getItem(key)] as const
  );
  localStorage.clear();
  preserved.forEach(([key, value]) => {
    if (value !== null) localStorage.setItem(key, value);
  });
};

export const getValidIntegerOrNull = (key: string): number | null | undefined => {
  const raw = localStorage.getItem(key);

  if (raw === null || raw === "null") return null;

  const num = Number(raw);
  return Number.isInteger(num) ? num : undefined;
};

export const isValidEditionId = (): number | null => {
  const editionIdRaw = localStorage.getItem("editionId");
  const editionId = Number(editionIdRaw);

  return Number.isInteger(editionId) && editionId > 0 ? editionId : null;
};
